// extracted by mini-css-extract-plugin
module.exports = {"form":"form__1pXD-","body":"body__1yjjT"};